import { ProductHelper } from '#/global/helper/Product/ProductHelper'

export default {
    cz: {
        toCart: 'Do košíku',
        demand: 'Poptat',
        labelAddToCart: (quantity: number, unit: string) => (
            <>
                do košíku přidáte
                {' '}
                <strong>
                    {ProductHelper.formatQuantity(quantity)}
                    {' '}
                    {ProductHelper.formatUnit(unit)}
                </strong>
            </>
        ),
        addToCart: 'Přidat',
        addedToCart: 'Přidáno',
        unit: (unit: string) => `za ${unit}`,
        withDPH: 's DPH',
        total: 'celkem',
    },
    sk: {
        toCart: 'Do košíka',
        demand: 'Na dopyt',
        labelAddToCart: (quantity: number, unit: string) => (
            <>
                do košíka pridáte
                {' '}
                <strong>
                    {ProductHelper.formatQuantity(quantity)}
                    {' '}
                    {ProductHelper.formatUnit(unit)}
                </strong>
            </>
        ),
        addToCart: 'Pridať',
        addedToCart: 'Pridané',
        unit: (unit: string) => `za ${unit}`,
        withDPH: 's DPH',
        total: 'celkom',
    },
}
